import React from 'react'
import MeterIndicator from '../MeterIndicator'

const IAWorkflowSection = () => {

  return (
    <div className='il-ia-workflow-section'>
        <h1 className="il-ia-workflow-title">
          Cómo funciona
        </h1>
        <div className="il-ia-workflow-blocks-container" id='first-block'>
          <MeterIndicator/>
          <div className="il-ia-workflow-block first" >
            <div className="il-ia-workflow-block-left">

            </div>
            <div className="il-ia-workflow-block-right">
                <h2>Diagnóstico Institucional</h2>
                <p>Diagnostica el estado actual del bienestar en tu institución con alguno de nuestros cuestionarios de bienestar institucional.</p>
            </div>
          </div>

          <div className="il-ia-workflow-block second">
            <div className="il-ia-workflow-block-left">
              <h2>Intervenciones basadas en evidencia</h2>
              <p>Tus resultados serán analizados por nuestra red que los conectará con decenas de posibles intervenciones a nivel institucional, por unidad, o a nivel de colaborador</p>
            </div>
            <div className="il-ia-workflow-block-right">
              
            </div>
          </div>

          <div className="il-ia-workflow-block third">
            <div className="il-ia-workflow-block-left">

            </div>
            <div className="il-ia-workflow-block-right">
                <h2>Recomendaciones Inteligentes</h2>
              <p>Recibe una recomendación de plan de intervenciones para mejorar de la forma más eficiente y efectiva posible el bienestar mental de tus colaboradores.</p>
            </div>
          </div>

          <div className="il-ia-workflow-block fourth" >
            <div className="il-ia-workflow-block-left">
              <h2>Crea tu Plan de Bienestar</h2>

              <p>Implementa un plan de trabajo institucional y gestiona su aplicación a través de Terapi. Mide tus resultados para evaluar de forma clara la efectividad de tus esfuerzos de bienestar.</p>
            </div>
            <div className="il-ia-workflow-block-right">
              
            </div>
          </div>

        </div>
    </div>
  )
}

export default IAWorkflowSection